'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('./index.css');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _finbLogo = require('./img/finb-logo.svg');

var _finbLogo2 = _interopRequireDefault(_finbLogo);

var _linkedin = require('./img/linkedin.svg');

var _linkedin2 = _interopRequireDefault(_linkedin);

var _fcb = require('./img/fcb.svg');

var _fcb2 = _interopRequireDefault(_fcb);

var _insta = require('./img/insta.svg');

var _insta2 = _interopRequireDefault(_insta);

var _twitter = require('./img/twitter.svg');

var _twitter2 = _interopRequireDefault(_twitter);

var _icPhone = require('./img/ic-phone.svg');

var _icPhone2 = _interopRequireDefault(_icPhone);

var _icEmail = require('./img/ic-email.svg');

var _icEmail2 = _interopRequireDefault(_icEmail);

var _useScreenSize = require('../../hoc/useScreenSize');

var _useScreenSize2 = _interopRequireDefault(_useScreenSize);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FooterNew = function FooterNew() {
  var _ref = (0, _useScreenSize2.default)(),
      isMobile = _ref.isMobile,
      isTablet = _ref.isTablet;

  var scrollToTop = function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  var handleGoToHomepage = function handleGoToHomepage() {
    window.location.href = "/";
  };

  return _react2.default.createElement('div', {
    className: 'footer-section'
  }, _react2.default.createElement('div', {
    className: 'footer-line'
  }), _react2.default.createElement('div', {
    className: 'footer'
  }, _react2.default.createElement('div', {
    className: 'logo',
    onClick: handleGoToHomepage
  }, _react2.default.createElement('img', {
    src: _finbLogo2.default,
    alt: 'logo',
    className: 'logo'
  })), _react2.default.createElement('div', {
    className: 'footer-links-section'
  }, _react2.default.createElement('a', {
    className: 'footer-mobile-link-small',
    href: 'javascript:void(0)'
  }, 'Pages'), _react2.default.createElement('a', {
    href: '/terms',
    className: 'footer-links'
  }, 'Terms of Service'), _react2.default.createElement('a', {
    href: '/privacy',
    className: 'footer-links'
  }, 'Privacy Policy'), _react2.default.createElement('a', {
    href: '/cookie',
    className: 'footer-links'
  }, 'Cookies')), _react2.default.createElement('div', {
    className: 'socials-section-footer'
  }, _react2.default.createElement('a', {
    className: 'footer-mobile-link-small',
    href: 'javascript:void(0)'
  }, 'Socials'), _react2.default.createElement('div', {
    className: 'socials-icons'
  }, _react2.default.createElement('a', {
    href: 'https://www.facebook.com',
    target: '_blank',
    rel: 'noopener noreferrer'
  }, _react2.default.createElement('img', {
    src: _fcb2.default,
    alt: '',
    className: 'social-icon'
  })), _react2.default.createElement('a', {
    href: 'https://www.linkedin.com',
    target: '_blank',
    rel: 'noopener noreferrer'
  }, _react2.default.createElement('img', {
    src: _linkedin2.default,
    alt: '',
    className: 'social-icon'
  })), _react2.default.createElement('a', {
    href: 'https://www.instagram.com',
    target: '_blank',
    rel: 'noopener noreferrer'
  }, _react2.default.createElement('img', {
    src: _insta2.default,
    alt: '',
    className: 'social-icon'
  })), _react2.default.createElement('a', {
    href: 'https://www.twitter.com',
    target: '_blank',
    rel: 'noopener noreferrer'
  }, _react2.default.createElement('img', {
    src: _twitter2.default,
    alt: '',
    className: 'social-icon'
  }))), !isMobile && !isTablet && _react2.default.createElement('div', {
    className: 'socials-section-footer'
  }, _react2.default.createElement('a', {
    className: 'footer-mobile-link-small',
    href: 'javascript:void(0)'
  }, 'Get in touch'), _react2.default.createElement('button', {
    className: 'global-button'
  }, 'Send a message'))), (isMobile || isTablet) && _react2.default.createElement('div', {
    className: 'socials-section-footer'
  }, _react2.default.createElement('a', {
    className: 'footer-mobile-link-small',
    href: 'javascript:void(0)'
  }, 'Get in touch'), _react2.default.createElement('button', {
    className: 'global-button'
  }, 'Send a message')), _react2.default.createElement('div', {
    className: 'socials-section-footer'
  }, _react2.default.createElement('a', {
    className: 'footer-mobile-link-small',
    href: 'javascript:void(0)'
  }, 'Contacts'), _react2.default.createElement('p', {
    className: 'footer-contact-text'
  }, 'Finbursa Technologies ltd. ', _react2.default.createElement('br', null), 'Office 105, DIFC, United Arab Emirates ', _react2.default.createElement('br', null), 'PO BOX 507211 Dubai UAE'), _react2.default.createElement('div', {
    className: 'footer-contact-links-section'
  }, _react2.default.createElement('div', {
    className: 'footer-contact-links'
  }, _react2.default.createElement('div', null, _react2.default.createElement('img', {
    src: _icPhone2.default,
    alt: ''
  })), _react2.default.createElement('p', {
    className: 'footer-links footer-links-mobile'
  }, '0097144019452')), _react2.default.createElement('div', {
    className: 'footer-contact-links'
  }, _react2.default.createElement('div', null, _react2.default.createElement('img', {
    src: _icEmail2.default,
    alt: ''
  })), _react2.default.createElement('a', {
    href: 'mailto:support@finbursa.com',
    className: 'footer-links footer-links-mobile'
  }, 'support@finbursa.com'))))), _react2.default.createElement('p', {
    className: 'copyright'
  }, 'Copyright \xA9 2025 Finbursa Technologies ltd. | All rights reserved.'));
};

exports.default = FooterNew;